/* Matraws — produktkort "holo-lys": et lysskær og holo-foil følger cursoren
   hen over billedet (som at vippe et holo-kort i hånden). Kortet står stille.
   Kun fine pointer; respekterer reduced-motion. */
(function () {
  if (window.__mtwPcFx) return;
  window.__mtwPcFx = 1;

  var ok = window.matchMedia
    && window.matchMedia('(hover: hover) and (pointer: fine)').matches
    && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!ok) return;

  function bind(scope) {
    var cards = (scope || document).querySelectorAll('.product-card');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      if (card.__mtwFx) continue;
      var item = card.closest('.product-card-item');
      if (item && item.getAttribute('data-mtw-available') === 'false') { card.__mtwFx = 1; continue; }
      var img = card.querySelector('.product-card-img');
      if (!img) continue;
      card.__mtwFx = 1;
      (function (img) {
        img.addEventListener('pointermove', function (e) {
          var r = img.getBoundingClientRect();
          img.style.setProperty('--mx', ((e.clientX - r.left) / r.width * 100).toFixed(1) + '%');
          img.style.setProperty('--my', ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%');
        });
      })(img);
    }
  }

  function init() {
    bind(document);
    document.addEventListener('shopify:section:load', function (e) { bind(e.target || document); });
    // Kort indsat med JS (forsidens faner, assets/mtw-home-tabs.js)
    document.addEventListener('mtw:kort-indsat', function (e) { bind(e.target || document); });
    // Re-bind når kollektions-filter/søgning swapper nye kort ind
    var grid = document.getElementById('CollectionProductsParent');
    if (grid && 'MutationObserver' in window) {
      var t;
      new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () { bind(grid); }, 120); })
        .observe(grid, { childList: true, subtree: true });
    }
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

/* Skjul ReStock-appens 'Giv mig besked'-knap overalt UNDTAGEN hovedproduktets
   på produktsiden (vi bruger vores egen rene notify-knap på kort). Appen
   injicerer også knapper i relaterede/anbefalede produktkort på produktsiden —
   de er bredere end kortene og flyder ud over dem, så de skjules også.
   Én CSS-regel er robust mod async-injektion og kræver ingen MutationObserver
   på hele siden. */
(function () {
  if (window.__mtwHideRestock) return;
  window.__mtwHideRestock = 1;
  var onPdp = /\/products\//.test(window.location.pathname);
  var SEL = ['.restock-alerts-notify-button', '[class*="restock-alerts-notify-button"]'];
  var regel = SEL.map(function (sel) {
    // PDP: behold kun hovedproduktets knap — knapper inde i produktkort skjules.
    return onPdp ? '.product-card-item ' + sel + ', .product-card ' + sel : sel;
  }).join(', ');
  var style = document.createElement('style');
  style.textContent = regel + '{display:none!important}';
  document.head.appendChild(style);
})();
